<template>
    <div class="card">
        <v-app>
            <div v-if="error" class="alert alert-danger" role="alert" style="margin-top:20px;">{{ message}}</div>

            <div class="card-body" v-if="!error">
                <div>
                    <div class="row">
                        <div class="form-group col-md-2 mb-0 py-0">
                            <FieldDataLoading v-if="signal_providers_loading"></FieldDataLoading>
                            <template v-if="!signal_providers_loading">
                                <v-container fluid>
                                    <v-select
                                        v-model="signal_providers"
                                        :items="all_signal_providers"
                                        label="Provider"
                                        multiple
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                            +{{ signal_providers.length - 1 }}
                                        </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_signal_providers" placeholder="Search" @input="search('signal_providers')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item
                                                ripple
                                                @click="toggle('signal_providers')"
                                            >
                                                <v-list-item-action>
                                                    <v-icon :color="signal_providers.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon('signal_providers') }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select all
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                        <div class="form-group col-md-3 mb-0 py-0">
                            <FieldDataLoading v-if="segments_loading"></FieldDataLoading>
                            <template v-if="! segments_loading">
                                <v-container fluid>
                                    <v-select
                                        v-model="segments"
                                        :items="all_segments"
                                        label="Segment"
                                        multiple
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                            +{{ segments.length - 1 }}
                                        </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_segments" placeholder="Search" @input="search('segments')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item
                                                ripple
                                                @click="toggle('segments')"
                                            >
                                                <v-list-item-action>
                                                    <v-icon :color="segments.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon('segments') }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select all
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                        <div class="form-group col-md-3 mb-0 py-0">
                            <FieldDataLoading v-if="categories_loading"></FieldDataLoading>
                            <template v-if="! categories_loading">
                                <v-container fluid>
                                    <v-select
                                        v-model="categories"
                                        :items="all_categories"
                                        label="Category"
                                        multiple
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                            +{{ categories.length - 1 }}
                                        </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_categories" placeholder="Search" @input="search('categories')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item
                                                ripple
                                                @click="toggle('categories')"
                                            >
                                                <v-list-item-action>
                                                    <v-icon :color="categories.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon('categories') }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select all
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                        <div class="form-group col-md-4 mb-0 py-0">
                            <FieldDataLoading v-if="analysis_data_loading"></FieldDataLoading>
                            <template v-if="! analysis_data_loading">
                                <v-container fluid>
                                    <v-select
                                        v-model="analysis_data"
                                        :items="all_analysis_data"
                                        label="POI"
                                        multiple
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                            +{{ analysis_data.length - 1 }}
                                        </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_analysis_data" placeholder="Search" @input="search('analysis_data')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item
                                                ripple
                                                @click="toggle('analysis_data')"
                                            >
                                                <v-list-item-action>
                                                    <v-icon :color="analysis_data.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon('analysis_data') }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select all
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                    </div>
                    <div class="row">
                        <div class="form-group col-md-2 mb-0 py-0">
                            <FieldDataLoading v-if="reviews_loading"></FieldDataLoading>
                            <template v-if="! reviews_loading">
                                <v-container fluid>
                                    <v-select
                                        v-model="reviews"
                                        :items="all_reviews"
                                        label="Review (Beta)"
                                        multiple
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                            +{{ reviews.length - 1 }}
                                        </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_reviews" placeholder="Search" @input="search('reviews')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item
                                                ripple
                                                @click="toggle('reviews')"
                                            >
                                                <v-list-item-action>
                                                    <v-icon :color="reviews.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon('reviews') }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select all
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                        <div class="form-group col-md-2 mb-0 py-0">
                            <FieldDataLoading v-if="cohorts_loading"></FieldDataLoading>
                            <template v-if="! cohorts_loading">
                                <v-container fluid>
                                    <v-select
                                        v-model="cohorts"
                                        :items="all_cohorts"
                                        label="Device Cohort"
                                        multiple
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                            +{{ cohorts.length - 1 }}
                                        </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_cohorts" placeholder="Search" @input="search('cohorts')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item
                                                ripple
                                                @click="toggle('cohorts')"
                                            >
                                                <v-list-item-action>
                                                    <v-icon :color="cohorts.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon('cohorts') }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select all
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                        <div class="form-group col-md-2 mb-0 py-0">
                            <v-menu
                                v-model="startDateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="start_date"
                                        label="Start Date"
                                        clearable
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    header-color="#fb7e42"
                                    color="#fb7e42"
                                    v-model="start_date"
                                    @input="startDateMenu = false"
                                    :max="end_date"
                                ></v-date-picker>
                            </v-menu>
                        </div><!--form-group-->
                        <div class="form-group col-md-2 mb-0 py-0">
                            <v-menu
                                v-model="endDateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="end_date"
                                        label="End Date"
                                        clearable
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    header-color="#fb7e42"
                                    color="#fb7e42"
                                    v-model="end_date"
                                    @input="endDateMenu = false"
                                    :min="start_date"
                                ></v-date-picker>
                            </v-menu>
                        </div><!--form-group-->
                        <div class="form-group col-md-2 mb-0 py-0">
                            <FieldDataLoading v-if="addresses_loading"></FieldDataLoading>
                            <template v-if="! addresses_loading">
                                <v-container fluid>
                                    <v-select
                                        v-model="addresses"
                                        :items="all_addresses"
                                        label="Address"
                                        multiple
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                            +{{ addresses.length - 1 }}
                                        </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_addresses" placeholder="Search" @input="search('addresses')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item
                                                ripple
                                                @click="toggle('addresses')"
                                            >
                                                <v-list-item-action>
                                                    <v-icon :color="addresses.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon('addresses') }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select all
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                        <div class="form-group col-md-2 mb-0 py-0">
                            <FieldDataLoading v-if="location_names_loading"></FieldDataLoading>
                            <template v-if="! location_names_loading">
                                <v-container fluid>
                                    <v-select
                                        v-model="location_names"
                                        :items="all_location_names"
                                        label="Location Name"
                                        multiple
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                            +{{ location_names.length - 1 }}
                                        </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_location_names" placeholder="Search" @input="search('location_names')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item
                                                ripple
                                                @click="toggle('location_names')"
                                            >
                                                <v-list-item-action>
                                                    <v-icon :color="location_names.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon('location_names') }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select all
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                    </div>
                    <div class="row">
                        <div class="form-group col-md-2 mb-0 py-0">
                            <FieldDataLoading v-if="cities_loading"></FieldDataLoading>
                            <template v-if="! cities_loading">
                                <v-container fluid>
                                    <v-select
                                        v-model="cities"
                                        :items="all_cities"
                                        label="City"
                                        multiple
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                            +{{ cities.length - 1 }}
                                        </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_cities" placeholder="Search" @input="search('cities')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item
                                                ripple
                                                @click="toggle('cities')"
                                            >
                                                <v-list-item-action>
                                                    <v-icon :color="cities.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon('cities') }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select all
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                        <div class="form-group col-md-2 mb-0 py-0">
                            <FieldDataLoading v-if="dmas_loading"></FieldDataLoading>
                            <template v-if="! dmas_loading">
                                <v-container fluid>
                                    <v-select
                                        v-model="dmas"
                                        :items="all_dmas"
                                        label="DMA"
                                        multiple
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                            +{{ dmas.length - 1 }}
                                        </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_dmas" placeholder="Search" @input="search('dmas')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item
                                                ripple
                                                @click="toggle('dmas')"
                                            >
                                                <v-list-item-action>
                                                    <v-icon :color="dmas.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon('dmas') }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select all
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                        <div class="form-group col-md-2 mb-0 py-0">
                            <FieldDataLoading v-if="countries_loading"></FieldDataLoading>
                            <template v-if="! countries_loading">
                                <v-container fluid>
                                    <v-select
                                        v-model="countries"
                                        :items="all_countries"
                                        label="Country"
                                        multiple
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                            +{{ countries.length - 1 }}
                                        </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_countries" placeholder="Search" @input="search('countries')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item
                                                ripple
                                                @click="toggle('countries')"
                                            >
                                                <v-list-item-action>
                                                    <v-icon :color="countries.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon('countries') }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select all
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                        <div class="form-group col-md-2 mb-0 py-0">
                            <FieldDataLoading v-if="states_loading"></FieldDataLoading>
                            <template v-if="! states_loading">
                                <v-container fluid>
                                    <v-select
                                        v-model="states"
                                        :items="all_states"
                                        label="State"
                                        multiple
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                            +{{ states.length - 1 }}
                                        </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_states" placeholder="Search" @input="search('states')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item
                                                ripple
                                                @click="toggle('states')"
                                            >
                                                <v-list-item-action>
                                                    <v-icon :color="states.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon('states') }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select all
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                        <div class="form-group col-md-3 mb-0 py-0">
                            <FieldDataLoading v-if="companies_loading"></FieldDataLoading>
                            <template v-if="! companies_loading">
                                <v-container fluid>
                                    <v-select
                                        v-model="companies"
                                        :items="all_companies"
                                        label="CompanyID"
                                        multiple
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.substr(0, 7) }}<span v-if="item.length > 7">...</span></span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                            +{{ companies.length - 1 }}
                                        </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_companies" placeholder="Search" @input="search('companies')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item
                                                ripple
                                                @click="toggle('companies')"
                                            >
                                                <v-list-item-action>
                                                    <v-icon :color="companies.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon('companies') }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select all
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                    </div>
                    <div class="row">
                        <div class="form-group col-md-3 mb-0 py-0">
                            <FieldDataLoading v-if="keys_loading"></FieldDataLoading>
                            <template v-if="! keys_loading">
                                <v-container fluid>
                                    <v-select
                                        v-model="keys"
                                        :items="all_keys"
                                        label="PlaceKey"
                                        multiple
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text.substr(0, 10) }}<span v-if="item.text.length > 10">...</span></span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                            +{{ keys.length - 1 }}
                                        </span>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_keys" placeholder="Search" @input="search('keys')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item
                                                ripple
                                                @click="toggle('keys')"
                                            >
                                                <v-list-item-action>
                                                    <v-icon :color="keys.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon('keys') }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select all
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                        <div class="form-group col-md-3 mb-0 py-0">
                            <v-textarea
                                v-model="zip_codes"
                                label="Zip Codes"
                                rows="1"
                                hint="One zip code in one row. Press Enter for new row."
                                auto-grow
                            ></v-textarea>
                        </div><!--form-group-->
                    </div>
                    <div class="row">
                        <v-divider class="mb-0 mt-2"></v-divider>
                    </div>
                    <div class="row">
                        <div class="col-md-4 offset-md-8 text-right">
                            <button @click="renderDashboard()" class="btn btn-outline-warning" v-show="quickSightLoaded">
                                <i class="fas fa-sync-alt"></i>
                                Refresh UI
                            </button>
                            <button @click="createNewActivation()" class="btn btn-outline-success">
                                <i class="fas fa-plus"></i>
                                Create Audience
                            </button>
                        </div>
                    </div>
                </div>

                <div class="row mt-3" v-show="quickSightLoaded">
                    <div class="w-100" id="dashboardContainer"></div>
                </div>
            </div><!--card-body-->
        </v-app>

        <CreateNewPrivateAudience v-if="showCreateDialog" :data-object="dataObject"></CreateNewPrivateAudience>
    </div><!--card-->
</template>

<script>
import api from '../../api/analyses/poi-locations'
import FieldDataLoading from "../../components/general/FieldDataLoading";
import CreateNewPrivateAudience from "../../components/analyses/CreateNewPrivateAudienceDev";
import mixins from '../../mixin'

export default {
    name: "PoiLocation",
    mixins: [mixins],
    data: () => ({
        dataObject: {
            type: 'POI',
            providers: [],
            segments: [],
            categories: [],
            brands: [],
            countries: [],
            states: [],
            dmas: [],
            cities: [],
            zipcodes: '',
            startDate: '',
            endDate: '',
        },
        showCreateDialog: false,

        error: false,
        message: '',

        analysis_type: 'POI',

        all_signal_providers: [],
        all_signal_providers_copy: [],
        signal_providers: [],
        search_signal_providers: '',
        signal_providers_loading: true,

        all_segments: [],
        all_segments_copy: [],
        segments: [],
        search_segments: '',
        segments_loading: true,

        all_categories: [],
        all_categories_copy: [],
        categories: [],
        search_categories: '',
        categories_loading: true,

        all_analysis_data: [],
        all_analysis_data_copy: [],
        analysis_data: [],
        search_analysis_data: '',
        analysis_data_loading: true,

        all_reviews: [],
        all_reviews_copy: [],
        reviews: [],
        search_reviews: '',
        reviews_loading: true,

        all_cohorts: [],
        all_cohorts_copy: [],
        cohorts: [],
        search_cohorts: '',
        cohorts_loading: true,

        startDateMenu: false,
        start_date: '',
        convStartDate: '',

        endDateMenu: false,
        end_date: '',
        convEndDate: '',

        all_addresses: [],
        all_addresses_copy: [],
        addresses: [],
        search_addresses: '',
        addresses_loading: true,

        all_location_names: [],
        all_location_names_copy: [],
        location_names: [],
        search_location_names: '',
        location_names_loading: true,

        all_cities: [],
        all_cities_copy: [],
        cities: [],
        search_cities: '',
        cities_loading: true,

        all_dmas: [],
        all_dmas_copy: [],
        dmas: [],
        search_dmas: '',
        dmas_loading: true,

        all_countries: [],
        all_countries_copy: [],
        countries: [],
        search_countries: '',
        countries_loading: true,

        all_states: [],
        all_states_copy: [],
        states: [],
        search_states: '',
        states_loading: true,

        all_companies: [],
        all_companies_copy: [],
        companies: [],
        search_companies: '',
        companies_loading: true,

        all_keys: [],
        all_keys_copy: [],
        keys: [],
        search_keys: '',
        keys_loading: true,

        zip_codes: '',

        dashboard: {},
        dataInitialLoading: true,
        quickSightInitialLoading: true,
        isLoading: true,
        quickSightLoaded: false,

        dataReload: false,
        dataField: '',
    }),
    components: {
        FieldDataLoading,
        CreateNewPrivateAudience
    },
    methods: {
        createNewActivation() {
            this.showCreateDialog = true
        },
        async fetchQuickSightAccess() {
            await api.getQuickSightDashboard()
                .then(res => {
                    this.renderInitialDashboard(res.data)
                })
        },
        renderInitialDashboard(url) {
            let containerDiv = document.getElementById("dashboardContainer");

            const options = {
                url: url,
                container: containerDiv,
                height: "AutoFit",
                loadingHeight: "700px",
                width: "100%",
                scrolling: "no",
                parameters: {
                    Client: this.signal_providers,
                    Segment: this.segments,
                    Category: this.categories,
                    POI: this.analysis_data,
                    Review: this.reviews,
                    // Cohort: this.cohorts,
                    startDate: this.convStartDate,
                    endDate: this.convEndDate,
                    Address: this.addresses,
                    Name: this.location_names,
                    City: this.cities,
                    DMA: this.dmas,
                    Country: this.countries,
                    State: this.states,
                    CompanyID: this.companies,
                    // PlaceKey: this.keys,
                    ZipCode: this.zip_codes ? this.zip_codes.split("\n") : ''
                }
            };
            this.dashboard = QuickSightEmbedding.embedDashboard(options)
            this.dashboard.on("load", this.loadingFinished)
        },
        loadingFinished() {
            this.quickSightInitialLoading = false
            this.renderDashboard()
        },
        renderDashboard() {
            if (!this.dataInitialLoading && !this.quickSightInitialLoading) {

                this.dashboard.setParameters({
                    Client: this.signal_providers,
                    Segment: this.segments,
                    Category: this.categories,
                    POI: this.analysis_data,
                    Review: this.reviews,
                    // Cohort: this.cohorts,
                    startDate: this.convStartDate,
                    endDate: this.convEndDate,
                    Address: this.addresses,
                    Name: this.location_names,
                    City: this.cities,
                    DMA: this.dmas,
                    Country: this.countries,
                    State: this.states,
                    CompanyID: this.companies,
                    // PlaceKey: this.keys,
                    ZipCode: this.zip_codes ? this.zip_codes.split("\n") : ''
                })
                this.quickSightLoaded = true
            }
        },
        async fetchInitialData() {
            await api.getInitialData()
                .then(res => {
                    this.all_signal_providers = res.data.providers
                    this.all_signal_providers_copy = res.data.providers
                    this.signal_providers_loading = false

                    this.all_segments = res.data.segments
                    this.all_segments_copy = res.data.segments
                    this.segments_loading = false

                    this.all_categories = res.data.categories
                    this.all_categories_copy = res.data.categories
                    this.categories_loading = false

                    this.all_analysis_data = res.data.analysis_data
                    this.all_analysis_data_copy = res.data.analysis_data
                    this.analysis_data_loading = false

                    this.all_reviews = res.data.reviews
                    this.all_reviews_copy = res.data.reviews
                    this.reviews_loading = false

                    this.all_cohorts = res.data.cohorts
                    this.all_cohorts_copy = res.data.cohorts
                    this.cohorts_loading = false

                    this.all_addresses = res.data.addresses
                    this.all_addresses_copy = res.data.addresses
                    this.addresses_loading = false

                    this.all_cities = res.data.cities
                    this.all_cities_copy = res.data.cities
                    this.cities_loading = false

                    this.all_location_names = res.data.location_names
                    this.all_location_names_copy = res.data.location_names
                    this.location_names_loading = false

                    this.all_dmas = res.data.dmas
                    this.all_dmas_copy = res.data.dmas
                    this.dmas_loading = false

                    this.all_countries = res.data.countries
                    this.all_countries_copy = res.data.countries
                    this.countries_loading = false

                    this.all_states = res.data.states
                    this.all_states_copy = res.data.states
                    this.states_loading = false

                    this.all_companies = res.data.companies
                    this.all_companies_copy = res.data.companies
                    this.companies_loading = false

                    this.all_keys = res.data.keys
                    this.all_keys_copy = res.data.keys
                    this.keys_loading = false

                    this.dataInitialLoading = false
                })
        },
        async fetchSignalProviders() {
            await api.getProviders()
                .then(res => {
                    this.all_signal_providers = res.data
                    this.all_signal_providers_copy = res.data
                    this.signal_providers_loading = false
                })
        },
        async fetchSegments() {
            await api.getSegments()
                .then(res => {
                    this.all_segments = res.data
                    this.all_segments_copy = res.data
                    this.segments_loading = false
                })
        },
        async fetchSegmentsId() {
            await api.getSegments({
                type: 'id',
                segments: this.segments
            })
            .then(res => {
                this.dataObject.segments = res.data.map(item => item.value)
            })
        },
        async fetchCategories() {
            await api.getCategories()
                .then(res => {
                    this.all_categories = res.data
                    this.all_categories_copy = res.data
                    this.categories_loading = false
                })
        },
        async fetchCategoriesId() {
            await api.getCategories({
                type: 'id',
                categories: this.categories
            })
            .then(res => {
                this.dataObject.categories = res.data.map(item => item.value)
            })
        },
        async fetchAnalysisData() {
            await api.getPois({
                categories: this.categories,
            })
                .then(res => {
                    this.all_analysis_data = res.data
                    this.all_analysis_data_copy = res.data
                    this.analysis_data_loading = false
                })
        },
        async fetchAnalysisDataId() {
            await api.getPois({
                type: 'id',
                pois: this.analysis_data
            })
            .then(res => {
                this.dataObject.brands = res.data.map(item => item.value)
            })
        },
        async fetchReviews() {
            await api.getReviews()
            .then(res => {
                this.all_reviews = res.data
                this.all_reviews_copy = res.data
                this.reviews_loading = false
            })
        },
        async fetchCohorts() {
            await api.getCohorts()
                .then(res => {
                    this.all_cohorts = res.data
                    this.all_cohorts_copy = res.data
                    this.cohorts_loading = false
                })
        },
        async fetchAddresses() {
            await api.getAddresses()
                .then(res => {
                    this.all_addresses = res.data
                    this.all_addresses_copy = res.data
                    this.addresses_loading = false
                })
        },
        async fetchCities() {
            await api.getCities()
                .then(res => {
                    this.all_cities = res.data
                    this.all_cities_copy = res.data
                    this.cities_loading = false
                })
        },
        async fetchLocationNames() {
            await api.getLocationNames()
                .then(res => {
                    this.all_location_names = res.data
                    this.all_location_names_copy = res.data
                    this.location_names_loading = false
                })
        },
        async fetchDmas() {
            await api.getDmas()
                .then(res => {
                    this.all_dmas = res.data
                    this.all_dmas_copy = res.data
                    this.dmas_loading = false
                })
        },
        async fetchCountries() {
            await api.getCountries()
                .then(res => {
                    this.all_countries = res.data
                    this.all_countries_copy = res.data
                    this.countries_loading = false
                })
        },
        async fetchStates() {
            await api.getStates()
                .then(res => {
                    this.all_states = res.data
                    this.all_states_copy = res.data
                    this.states_loading = false
                })
        },
        async fetchCompanies() {
            await api.getCompanies()
                .then(res => {
                    this.all_companies = res.data
                    this.all_companies_copy = res.data
                    this.companies_loading = false
                })
        },
        async fetchKeys() {
            await api.getKeys()
                .then(res => {
                    this.all_keys = res.data
                    this.all_keys_copy = res.data
                    this.keys_loading = false
                })
        },
        async fetchChangedData(field) {
            this.dataReloading(field)
            await api.getDataByChangedField({
                field: field,
                segments: this.segments,
                categories: this.categories,
                pois: this.analysis_data,
                countries: this.countries,
                states: this.states,
                dmas: this.dmas,
                cities: this.cities,
                addresses: this.addresses,
                locations: this.location_names,
                zipcodes: this.zip_codes
            })
            .then(res => {
                if (field === 'segments') {
                    this.all_categories = res.data.categories
                    this.all_categories_copy = res.data.categories
                    this.categories_loading = false

                    this.all_analysis_data = res.data.analysis_data
                    this.all_analysis_data_copy = res.data.analysis_data
                    this.analysis_data_loading = false

                    this.all_countries = res.data.countries
                    this.all_countries_copy = res.data.countries
                    this.countries_loading = false

                    this.all_states = res.data.states
                    this.all_states_copy = res.data.states
                    this.states_loading = false

                    this.all_dmas = res.data.dmas
                    this.all_dmas_copy = res.data.dmas
                    this.dmas_loading = false

                    this.all_cities = res.data.cities
                    this.all_cities_copy = res.data.cities
                    this.cities_loading = false

                    this.all_addresses = res.data.addresses
                    this.all_addresses_copy = res.data.addresses
                    this.addresses_loading = false

                    this.all_location_names = res.data.location_names
                    this.all_location_names_copy = res.data.location_names
                    this.location_names_loading = false
                }

                if (field === 'categories') {
                    this.all_analysis_data = res.data.analysis_data
                    this.all_analysis_data_copy = res.data.analysis_data
                    this.analysis_data_loading = false

                    this.all_countries = res.data.countries
                    this.all_countries_copy = res.data.countries
                    this.countries_loading = false

                    this.all_states = res.data.states
                    this.all_states_copy = res.data.states
                    this.states_loading = false

                    this.all_dmas = res.data.dmas
                    this.all_dmas_copy = res.data.dmas
                    this.dmas_loading = false

                    this.all_cities = res.data.cities
                    this.all_cities_copy = res.data.cities
                    this.cities_loading = false

                    this.all_addresses = res.data.addresses
                    this.all_addresses_copy = res.data.addresses
                    this.addresses_loading = false

                    this.all_location_names = res.data.location_names
                    this.all_location_names_copy = res.data.location_names
                    this.location_names_loading = false
                }

                if (field === 'analysis_data') {
                    this.all_countries = res.data.countries
                    this.all_countries_copy = res.data.countries
                    this.countries_loading = false

                    this.all_states = res.data.states
                    this.all_states_copy = res.data.states
                    this.states_loading = false

                    this.all_dmas = res.data.dmas
                    this.all_dmas_copy = res.data.dmas
                    this.dmas_loading = false

                    this.all_cities = res.data.cities
                    this.all_cities_copy = res.data.cities
                    this.cities_loading = false

                    this.all_addresses = res.data.addresses
                    this.all_addresses_copy = res.data.addresses
                    this.addresses_loading = false

                    this.all_location_names = res.data.location_names
                    this.all_location_names_copy = res.data.location_names
                    this.location_names_loading = false
                }

                if (field === 'countries') {
                    this.all_states = res.data.states
                    this.all_states_copy = res.data.states
                    this.states_loading = false

                    this.all_dmas = res.data.dmas
                    this.all_dmas_copy = res.data.dmas
                    this.dmas_loading = false

                    this.all_cities = res.data.cities
                    this.all_cities_copy = res.data.cities
                    this.cities_loading = false

                    this.all_addresses = res.data.addresses
                    this.all_addresses_copy = res.data.addresses
                    this.addresses_loading = false

                    this.all_location_names = res.data.location_names
                    this.all_location_names_copy = res.data.location_names
                    this.location_names_loading = false
                }

                if (field === 'states') {
                    this.all_dmas = res.data.dmas
                    this.all_dmas_copy = res.data.dmas
                    this.dmas_loading = false

                    this.all_cities = res.data.cities
                    this.all_cities_copy = res.data.cities
                    this.cities_loading = false

                    this.all_addresses = res.data.addresses
                    this.all_addresses_copy = res.data.addresses
                    this.addresses_loading = false

                    this.all_location_names = res.data.location_names
                    this.all_location_names_copy = res.data.location_names
                    this.location_names_loading = false
                }

                if (field === 'dmas') {
                    this.all_cities = res.data.cities
                    this.all_cities_copy = res.data.cities
                    this.cities_loading = false

                    this.all_addresses = res.data.addresses
                    this.all_addresses_copy = res.data.addresses
                    this.addresses_loading = false

                    this.all_location_names = res.data.location_names
                    this.all_location_names_copy = res.data.location_names
                    this.location_names_loading = false
                }

                if (field === 'cities') {
                    this.all_addresses = res.data.addresses
                    this.all_addresses_copy = res.data.addresses
                    this.addresses_loading = false

                    this.all_location_names = res.data.location_names
                    this.all_location_names_copy = res.data.location_names
                    this.location_names_loading = false
                }

                if (field === 'addresses') {
                    this.all_location_names = res.data.location_names
                    this.all_location_names_copy = res.data.location_names
                    this.location_names_loading = false
                }
            })
        },
        dataReloading(field) {
            if (field === 'segments') {
                this.categories_loading = true
                this.analysis_data_loading = true
                this.countries_loading = true
                this.states_loading = true
                this.dmas_loading = true
                this.cities_loading = true
                this.addresses_loading = true
                this.location_names_loading = true
            }
            if (field === 'categories') {
                this.analysis_data_loading = true
                this.countries_loading = true
                this.states_loading = true
                this.dmas_loading = true
                this.cities_loading = true
                this.addresses_loading = true
                this.location_names_loading = true
            }
            if (field === 'analysis_data') {
                this.countries_loading = true
                this.states_loading = true
                this.dmas_loading = true
                this.cities_loading = true
                this.addresses_loading = true
                this.location_names_loading = true
            }
            if (field === 'countries') {
                this.states_loading = true
                this.dmas_loading = true
                this.cities_loading = true
                this.addresses_loading = true
                this.location_names_loading = true
            }
            if (field === 'states') {
                this.dmas_loading = true
                this.cities_loading = true
                this.addresses_loading = true
                this.location_names_loading = true
            }
            if (field === 'dmas') {
                this.cities_loading = true
                this.addresses_loading = true
                this.location_names_loading = true
            }
            if (field === 'cities') {
                this.addresses_loading = true
                this.location_names_loading = true
            }
            if (field === 'addresses') {
                this.location_names_loading = true
            }
        },
        toggle(data) {
            this.$nextTick(() => {
                if (this.selectedAll(data)) {
                    this.$data[data] = []
                } else {
                    this.$data[data] = this.$data['all_' + data].map(a => {
                        return a.value
                    })
                }
            })
        },
        search(data) {
            if (!this.$data['search_' + data]) {
                this.$data['all_' + data] = this.$data['all_' + data + '_copy'];
            }
            this.$data['all_' + data] = this.$data['all_' + data + '_copy'].filter((item) => {
                if (data === 'countries') {
                    return item.text.toLowerCase().indexOf(this.$data['search_' + data].toLowerCase()) > -1 || item.value.toLowerCase().indexOf(this.$data['search_' + data].toLowerCase()) > -1;
                } else {
                    return item.text.toLowerCase().indexOf(this.$data['search_' + data].toLowerCase()) > -1;
                }
            })
        },
    },
    created() {
        this.fetchQuickSightAccess()
    },
    computed: {
        selectedAll() {
            return (data) => {
                return this.$data[data].length === this.$data['all_' + data].length
            }
        },
        selectedSome() {
            return (data) => {
                return this.$data[data].length > 0 && !this.selectedAll(data)
            }
        },
        icon() {
            return (data) => {
                if (this.selectedAll(data)) return 'mdi-close-box'
                if (this.selectedSome(data)) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            }
        },
        textLabel() {
            return (data, item) => {
                if (this.$data[data].length !== this.$data['all_' + data].length)
                    return item.text.substr(0, 7) + '...'
                return 'All'
            }
        }
    },
    watch: {
        signal_providers: function () {
            this.dataObject.providers = this.signal_providers
        },
        segments: function () {
            this.dataObject.segments = this.segments
            if (!this.dataInitialLoading && !this.quickSightInitialLoading) {
                this.fetchChangedData('segments')
            }
        },
        categories: function () {
            this.dataObject.categories = this.categories
            if (!this.dataInitialLoading && !this.quickSightInitialLoading) {
                this.fetchChangedData('categories')
            }
        },
        analysis_data: function () {
            this.dataObject.brands = this.analysis_data
            if (!this.dataInitialLoading && !this.quickSightInitialLoading) {
                this.fetchChangedData('analysis_data')
            }
        },
        addresses: function () {
            if (!this.dataInitialLoading && !this.quickSightInitialLoading) {
                this.fetchChangedData('addresses')
            }
        },
        location_names: function () {
            if (!this.dataInitialLoading && !this.quickSightInitialLoading) {
                this.fetchChangedData('location_names')
            }
        },
        cities: function () {
            this.dataObject.cities = this.cities
            if (!this.dataInitialLoading && !this.quickSightInitialLoading) {
                this.fetchChangedData('cities')
            }
        },
        dmas: function () {
            this.dataObject.dmas = this.dmas
            if (!this.dataInitialLoading && !this.quickSightInitialLoading) {
                this.fetchChangedData('dmas')
            }
        },
        countries: function () {
            this.dataObject.countries = this.countries
            if (!this.dataInitialLoading && !this.quickSightInitialLoading) {
                this.fetchChangedData('countries')
            }
        },
        states: function () {
            this.dataObject.states = this.states
            if (!this.dataInitialLoading && !this.quickSightInitialLoading) {
                this.fetchChangedData('states')
            }
        },
        zip_codes: function () {
            this.dataObject.zipcodes = this.zip_codes
        },
        start_date: function () {
            let date = new Date(this.start_date);
            this.dataObject.start_date = date.getFullYear() + '-' + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + date.getDate()).slice(-2);
            this.convStartDate = date.getFullYear() + '/' + ("0" + (date.getMonth() + 1)).slice(-2) + '/' + ("0" + date.getDate()).slice(-2);
        },
        end_date: function () {
            let date = new Date(this.end_date);
            this.dataObject.end_date = date.getFullYear() + '-' + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + date.getDate()).slice(-2);
            this.convEndDate = date.getFullYear() + '/' + ("0" + (date.getMonth() + 1)).slice(-2) + '/' + ("0" + date.getDate()).slice(-2);
        },
    },
    mounted() {
        this.fetchInitialData()
    }
}
</script>

<style scoped>

</style>